import { Language } from './utils/enums';

export const auth0EmailVerifiedKey = 'https://enlivio.com/email_verified';

export const defaultLanguage: Language = Language.GERMAN;

export const supportedLanguages: Language[] = Object.values(Language);
